// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.svg-map {
    width: 100%;
    height: 600px;
    stroke: #777;
    stroke-width: 1;
    stroke-linecap: round;
    stroke-linejoin: round;
}
.svg-map__location {
    cursor: pointer;
}
.svg-map__location:focus,
.svg-map__location:hover {
    outline: 0;
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-simple-south-korea-map-chart/dist/map.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,sBAAsB;AAC1B;AACA;IACI,eAAe;AACnB;AACA;;IAEI,UAAU;AACd","sourcesContent":[".svg-map {\n    width: 100%;\n    height: 600px;\n    stroke: #777;\n    stroke-width: 1;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n}\n.svg-map__location {\n    cursor: pointer;\n}\n.svg-map__location:focus,\n.svg-map__location:hover {\n    outline: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
